/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React, { type ComponentProps } from 'react';
import Picture from 'components/Picture/Picture';
import Statement from '../Statement/Statement';
import './StatementImage.scss';

const DEFAULT_IMAGE: NonNullable<StatementImageProps['image']> = {};

interface StatementImageProps {
  layout?: string;
  statement?: string;
  image?: ComponentProps<typeof Picture> & { description?: string };
}

/**
 * This is the StatementImage component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function StatementImage({
  layout = 'right',
  statement = '',
  image: { description, ...image } = DEFAULT_IMAGE,
}: StatementImageProps) {
  function renderDescription() {
    if (!description) return null;

    return <figcaption dangerouslySetInnerHTML={{ __html: description }} />;
  }

  return (
    <div className={`block statement-image layout-${layout}`}>
      <Statement>{statement}</Statement>
      <figure className="image" appear="true">
        <Picture {...image} />
        {renderDescription()}
      </figure>
    </div>
  );
}

export default StatementImage;
